<template>
  <div
    class="ai-response-text"
    v-html="renderedContent"
  ></div>
</template>

<script setup lang="ts">
import MarkdownIt from "markdown-it"
import { computed } from "vue"

import { sanitizeAiHtml } from "@/helpers/sanitizeAiHtml"

// AI content reaches us in two shapes: ready-made HTML (insights structuredContent) and plain
// Markdown (chat replies, SSE summaries). With html: true a render pass leaves existing markup
// untouched while still converting Markdown, so one path covers both. Sanitized before v-html.
const md = new MarkdownIt({ html: true, breaks: true, linkify: true })

const props = defineProps({
  content: {
    type: String,
    required: true
  }
})

const renderedContent = computed(() => sanitizeAiHtml(md.render(props.content)))
</script>
